import script from "./CartItems.vue?vue&type=script&setup=true&lang=js"
export * from "./CartItems.vue?vue&type=script&setup=true&lang=js"

import "./CartItems.vue?vue&type=style&index=0&id=623fc624&lang=scss"
import "./CartItems.vue?vue&type=style&index=1&id=623fc624&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-623fc624"]])

export default __exports__